import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Main from "./components/main";
import LaunchPad from "./pages/launchpad";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createWeb3Modal } from "@web3modal/wagmi/react";
import { WagmiProvider } from "wagmi";
import "@rainbow-me/rainbowkit/styles.css";
import {
  getDefaultConfig,
  RainbowKitProvider,
  DisclaimerComponent,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import DetailsIdo from "./pages/launchpad/details";
import HomePage from "./pages/homepage";
import CalendarIdo from "./pages/launchpad/calendar-ido";
import Term from "./pages/term";
import Policy from "./pages/policy";
import Airdrop from "./pages/airdrop";
import AirdropDetail from "./pages/airdrop/detail";
import NFT from "./pages/nft";
import { supportEVMChains, wagmiConfig } from "./config/wagmi";

function App() {
  const queryClient = new QueryClient();
  const projectId = "5f6c18132c6e21af2b276b34ad0af7ec";

  createWeb3Modal({
    wagmiConfig: wagmiConfig,
    projectId,
    enableAnalytics: true,
  });

  const configRain = getDefaultConfig({
    appName: "AppKits",
    projectId: "5f6c18132c6e21af2b276b34ad0af7ec",
    chains:  supportEVMChains,
    ssr: true,
  });

  const Disclaimer: DisclaimerComponent = ({ Text, Link }) => (
    <Text>
      Bys connecting your wallet, you agree to the{" "}
      <Link href="">Terms of use</Link> and acknowledge you have read and
      understand the protocol <Link href="">Documentation</Link>
    </Text>
  );

  return (
    <div className="App">
      <WagmiProvider config={configRain}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider
            // locale="en-US"
            appInfo={{
              appName: "BluewhaleX",
              disclaimer: Disclaimer,
            }}
            theme={darkTheme({
              accentColor: "#7b3fe4",
              accentColorForeground: "white",
              borderRadius: "medium",
              fontStack: "system",
              overlayBlur: "small",
            })}
          >
            <Main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/terms" element={<Term />} />
                <Route path="privacy" element={<Policy />} />
                <Route path="/launchpads" element={<LaunchPad />} />
                <Route path="/launchpads/:id" element={<DetailsIdo />} />
                <Route path="/calendar-ido" element={<CalendarIdo />} />
                <Route path="/airdrop" element={<Airdrop />} />
                <Route path="/airdrop/:id" element={<AirdropDetail />} />
                <Route path="*" element={<Navigate to="/" replace />} />
                <Route path="nft" element={<NFT />} />
              </Routes>
            </Main>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </div>
  );
}

export default App;
